//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Typography, useTheme } from '@mui/material'
import PoolList from '@react/components/pools/PoolList'
import { TopAppBar } from '@react/topbar/TopAppBar'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import AdminPoolList from './AdminPoolList'
import DemoManagement from './DemoManagement'

import { PoolCreateMultiStepForm } from './PoolCreate/PoolCreateMultiStepForm'

import AdminCompanyProfileList from './AdminCompanyProfileList'

import Width1600 from '@react/components/Width1600'
import WidthLimited from '@react/components/WidthLimited'
import ReportingPage from '@react/reporting/ReportingPage'

import AdminLiquidityAssets from './AdminLiquidityAssets'
import AdminPoolDetails from './AdminPoolDetails'
import CompanyProfileView from './CompanyProfileView'
import DefiExchangeRatePage from './DefiExchangeRatePage'

export default function AdminRouting(): React.ReactElement {
  const theme = useTheme()

  return (
    <Box
      data-testid="AdminRoundBoxWrapper"
      sx={{ height: '100vh', width: '100%', backgroundColor: theme.palette.background.canvas, overflow: 'scroll' }}
    >
      <TopAppBar />

      <Routes>
        <Route
          path="/"
          element={
            <Width1600>
              <AdminPoolList />
            </Width1600>
          }
        />
        <Route
          path="/reports/:reportDefinition"
          element={
            <Box data-testid="AdminRoundBox2" sx={{ margin: 'auto', marginTop: 3, height: '100vh', maxWidth: '100%' }}>
              <Box sx={{ height: '60px', display: 'flex', justifyContent: 'space-between' }}>
                <Typography align="left" sx={{ display: 'inline', float: 'left', fontWeight: 'bold' }} variant={'h4'}>
                  Lender Explorer
                </Typography>
              </Box>
              <ReportingPage />
            </Box>
          }
        />
        <Route
          path="/reports"
          element={
            <Box data-testid="AdminRoundBox3" sx={{ margin: 'auto', marginTop: 3, height: '100vh', maxWidth: '100%' }}>
              <Box sx={{ height: '60px', display: 'flex', justifyContent: 'space-between', paddingLeft: '15px' }}>
                <Typography align="left" sx={{ display: 'inline', float: 'left', fontWeight: 'bold' }} variant={'h4'}>
                  Reports
                </Typography>
              </Box>
              <ReportingPage />
            </Box>
          }
        />
        <Route
          path="/pools"
          element={
            <WidthLimited>
              <PoolList />
            </WidthLimited>
          }
        />
        <Route
          path="/pools/add/v2"
          element={
            <WidthLimited>
              <PoolCreateMultiStepForm />
            </WidthLimited>
          }
        />{' '}
        <Route
          path="/exchangeRate/:poolAddr"
          element={
            <Width1600>
              <DefiExchangeRatePage />
            </Width1600>
          }
        />
        <Route
          path="/pools/:poolAddr"
          element={
            <Width1600>
              <AdminPoolDetails />
            </Width1600>
          }
        />
        <Route path="/companyProfiles" element={<AdminCompanyProfileList />} />
        <Route path="/companyProfiles/:uuid" element={<CompanyProfileView />} />
        <Route
          path="/demo"
          element={
            <WidthLimited>
              <DemoManagement />
            </WidthLimited>
          }
        />
        <Route
          path="/liquidityAssets"
          element={
            <Width1600>
              <AdminLiquidityAssets />
            </Width1600>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Box>
  )
}
